<template>
  <md-card>        
    <md-card-content :style="'display: flex'">
      <v-combobox
        v-model="selectAtv"
        :items="itemsAtv"                      
        label="Selecione as Atividades"
        multiple
        small-chips
        hide-selected
        box
        persistent-hint
        clearable
        deletable-chips
        type=false
        background-color="#ffffff"
        style="margin-left: 5px; margin-right: 5px"
      ></v-combobox>    
      <v-combobox
        v-model="selectPrs"
        :items="itemsPrs"                      
        label="Selecione as Personas"
        multiple
        small-chips
        hide-selected
        box
        persistent-hint
        clearable
        deletable-chips
        background-color="#ffffff"
        style="margin-left: 5px; margin-right: 5px"
      ></v-combobox>   
      <v-combobox
        v-model="selectAnl"
        :items="itemsAnl"                      
        label="Selecione os Analistas"
        multiple
        small-chips
        hide-selected
        box
        persistent-hint
        clearable
        deletable-chips
        background-color="#ffffff"
        style="margin-left: 5px; margin-right: 5px"
      ></v-combobox>  
      <v-combobox
        v-model="selectArq"
        :items="itemsArq"                      
        label="Sem liberação para..."
        multiple
        small-chips
        hide-selected
        box
        persistent-hint
        clearable
        deletable-chips
        background-color="#ffffff"
        style="margin-left: 5px; margin-right: 5px"
      ></v-combobox>        
    </md-card-content>
  </md-card>
</template>
<script>
import * as ClientesService from "../../providers/clientes.service";
import * as Arquivos from "../../providers/arquivos.service";

export default {
  props: ["onChange"],  
  
  data() {
    var self = this;
    return {
      selectAtv: [],
      selectPrs: [],
      selectAnl: [],
      selectArq: [],
      itemsAtv: [],
      itemsPrs: [],
      itemsAnl: [],
      itemsArq: []
    };
  },

  created() {
    ClientesService.getClientesGrupos({}).then(r => {
      this.itemsAtv = r.Groups.ATIVIDADES;
      this.itemsPrs = r.Groups.PERSONAS;
      this.itemsAnl = r.Groups.ANALISTAS;
    });
    Arquivos.getArquivos().then(resp => {      
      this.itemsArq = resp.filter((e) => {return (e.ARQTIPO >= 1) && (e.ARQTIPO <= 3)}).map((e) => {
        return e.ARQVERSAO + ' (' + e.ARQNOME + ')'
      })
    });    
  },

  mounted() {
    if (localStorage.selectAtv)
      this.selectAtv = localStorage.selectAtv.split(',');    
    if (localStorage.selectPrs)
      this.selectPrs = localStorage.selectPrs.split(',');    
    if (localStorage.selectAnl)
      this.selectAnl = localStorage.selectAnl.split(',');    
    if (localStorage.selectArq)
      this.selectArq = localStorage.selectArq.split(',');    
  },

  watch: {
    selectAtv: function(val) {
      localStorage.selectAtv = this.selectAtv;
      this.onChange(this.selectAtv, this.selectPrs, this.selectAnl, this.selectArq);
    },
    selectPrs: function(val) {
      localStorage.selectPrs = this.selectPrs;
      this.onChange(this.selectAtv, this.selectPrs, this.selectAnl, this.selectArq);
    },
    selectAnl: function(val) {
      localStorage.selectAnl = this.selectAnl;
      this.onChange(this.selectAtv, this.selectPrs, this.selectAnl, this.selectArq);
    },
    selectArq: function(val) {
      localStorage.selectArq = this.selectArq;
      this.onChange(this.selectAtv, this.selectPrs, this.selectAnl, this.selectArq);
    }    
  },

  methods: {

  }
};
</script>
<style>
.v-list__tile__title {
  color: #000;
}
</style>